import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { useUyeMailGuncelleMutation } from '../../../gql/GeneratedGraphqlTypes'

const MailDeport = () => {
    const { email } = useParams<{ email: string }>()
    const [uyeMailGuncelleMutation, { data, loading, error }] = useUyeMailGuncelleMutation()
    console.log(email)
    useEffect(() => {
        if (email) {
            const runMutation = async () => {
                try {
                    await uyeMailGuncelleMutation({
                        variables: { email },
                    })
                } catch (e) {
                    console.error('Mutation error:', e)
                }
            }

            runMutation()
        }
    }, [email, uyeMailGuncelleMutation])

    return (
        <div style={{ padding: '40px', textAlign: 'center' }}>
            {loading ? (
                <p>İşleniyor...</p>
            ) : error ? (
                <p style={{ color: 'red' }}>Hata oluştu: {error.message}</p>
            ) : data?.uyeMailGuncelle?.success ? (
                <>
                    <h2>E-posta bildirimleri devre dışı bırakıldı.</h2>
                    <p>Bu e-posta adresi artık bilgilendirme mesajları almayacaktır.</p>
                </>
            ) : data?.uyeMailGuncelle?.message ? (
                <p>{data.uyeMailGuncelle.message}</p>
            ) : (
                <p>İşleniyor...</p>
            )}
        </div>
    )
}

export default MailDeport
